var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerWrapper"},[_c('div',{staticClass:"footerLeft"},[_vm._v("Copyright © 2011-"+_vm._s(_vm.currentYear)+"北京泽云瑞弘信息技术有限公司 "),_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.toFiling}},[_vm._v("京ICP备19045213号-1")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }